export interface UpdateDefaultParameterOrderListRequest {
  id: string
  selectReason: string
  collectionType: string
  traderCode: string
  acceptType: string
  buyDepartmentCode: string
  donorCode: string
  budgetYear: number | string
  budgetBranchCode: string
  budgetDepartmentCode: string
  budgetExpenseCode: string
  equipType: string
  shelfType: string
  handlingType: string
  orderNumbers: {
    orderBranchCode: string
    orderNumber: number | string
  }[]
  revision: number
  allBranchFlag: boolean
}

export function UpdateDefaultParameterOrderListRequestToJSON(
  value: UpdateDefaultParameterOrderListRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    select_reason: value.selectReason !== '' ? value.selectReason : undefined,
    collection_type:
      value.collectionType !== '' ? value.collectionType : undefined,
    trader_code: value.traderCode !== '' ? value.traderCode : undefined,
    accept_type: value.acceptType !== '' ? value.acceptType : undefined,
    buy_department_code:
      value.buyDepartmentCode !== '' ? value.buyDepartmentCode : undefined,
    donor_code: value.donorCode !== '' ? value.donorCode : undefined,
    budget_year: value.budgetYear !== '' ? value.budgetYear : undefined,
    budget_branch_code:
      value.budgetBranchCode !== '' ? value.budgetBranchCode : undefined,
    budget_department_code:
      value.budgetDepartmentCode !== ''
        ? value.budgetDepartmentCode
        : undefined,
    budget_expense_code:
      value.budgetExpenseCode !== '' ? value.budgetExpenseCode : undefined,
    equip_type: value.equipType !== '' ? value.equipType : undefined,
    shelf_type: value.shelfType !== '' ? value.shelfType : undefined,
    handling_type: value.handlingType !== '' ? value.handlingType : undefined,
    order_numbers:
      value.orderNumbers.length !== 0
        ? value.orderNumbers.map(value => {
            return {
              order_branch_code:
                value.orderBranchCode !== ''
                  ? value.orderBranchCode
                  : undefined,
              order_number:
                value.orderNumber !== '' ? value.orderNumber : undefined
            }
          })
        : undefined,
    revision: value.revision ? value.revision : undefined,
    all_branch_flag: value.allBranchFlag
  }
}
